
import { Component, Prop, Vue } from "vue-property-decorator";
import PreguntasFrecuentesComponent from "../components/PreguntasFrecuentesComponent.vue";

@Component({
  components: {
    PreguntasFrecuentesComponent,
  },
})
export default class PreguntasFrecuentes extends Vue {}
